import { Injectable } from '@angular/core';
import { Client } from '../../shared/services/client';
import { HttpClient } from '@angular/common/http';
import { RegularPayments, Scales } from '../_models/payments';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class RegularPaymentsService {
  private regularPaymentsArray: RegularPayments[];
  validationRagularPaymentsState = new Subject<boolean>();
  validationScalesSate = new Subject<boolean>();
  resScales: Scales[];
  saveScalesEvent = new Subject();
  scalesAfterResponce = new Subject();
  private isDirty: boolean;
  constructor(private http: HttpClient, private client: Client) {}

  getRegularPaymentArray(data: RegularPayments[]) {
    this.regularPaymentsArray = data;
  }
  getIsDirtyForm(value) {
    this.isDirty = value;
  }

  saveRegularPayments(tariffId: string) {
    console.log('RegularPaymentsService -> saveRegularPayments -> regularPaymentsArray', this.regularPaymentsArray);
    const requestdata = this.regularPaymentsArray.map(el => {
      if (!el.id) {
        delete el.id;
        return { ...el, tariff_plan_id: tariffId };
      } else {
        return el;
      }
    });

    if (this.isDirty) {
      this.createRequestSource(requestdata);
    } else {
      this.saveScalesEvent.next();
    }
  }

  private createRequestSource(data) {
    Observable.forkJoin(
      data.map((body: RegularPayments) => {
        if (body.id) {
          return this.updateRegularPayment(body);
        } else {
          return this.createRegularPayment(body);
        }
      })
    ).subscribe(res => {
      this.saveScalesEvent.next(res);
    });
  }
  saveScales(data) {
    if (data) {
      Observable.forkJoin(
        data.map((body: Scales) => {
          if (body.id) {
            return this.updateScale(body);
          } else if (body.regular_payment_id) {
            return this.createScale(body);
          }
        })
      ).subscribe(res => this.scalesAfterResponce.next(true));
    }
  }

  private createRegularPayment(obj: RegularPayments) {
    return this.http.post(this.client.getRegularPaymentsUrl(), obj);
  }

  private updateRegularPayment(obj: RegularPayments) {
    return this.http.put(this.client.getRegularPaymentsUrl(), obj);
  }

  removeRegularPayment(paymentId: string) {
    return this.http.request('DELETE', this.client.getRegularPaymentsUrl(), {
      body: { id: paymentId }
    });
  }

  private createScale(obj) {
    return this.http.post(this.client.getScalesUrl(), obj);
  }

  private updateScale(obj) {
    return this.http.put(this.client.getScalesUrl(), obj);
  }

  removeScale(scalesId: string) {
    return this.http.request('DELETE', this.client.getScalesUrl(), {
      body: { id: scalesId }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/driver-tariffs/services/regular-payments.service.ts